module.exports = new __parcel__URL__("ErrorGeneric.5fda5790.svg").toString();